import {
  EMBED_GUEST_LOGIN_CLOSE_MESSAGE_TYPE,
  EMBED_GUEST_LOGIN_OPEN_MESSAGE_TYPE,
  EMBED_RESIZE_MESSAGE_TYPE
} from "@/embed/constants";

export const postIframeData = (iframeData: {
  height: number;
  location: string;
  hostOrigin: string;
}): void => {
  if (typeof window === "undefined" || !iframeData.hostOrigin) {
    return;
  }

  window.parent.postMessage(
    {
      // `type` is additive for the unified loader. Legacy embed scripts read
      // only `height`/`location` and ignore unknown fields, so the original
      // contract (height + location === iframe.src) stays fully intact.
      type: EMBED_RESIZE_MESSAGE_TYPE,
      height: iframeData.height,
      location: iframeData.location,
      hostOrigin: iframeData.hostOrigin
    },
    iframeData.hostOrigin
  );
};

/** Tells the parent that the guest login embed was dismissed (e.g. close). `hostOrigin` must match the page embedding the iframe. */
export const postGuestLoginEmbedClose = (hostOrigin: string): void => {
  if (typeof window === "undefined" || !hostOrigin) {
    return;
  }

  window.parent.postMessage(
    {
      type: EMBED_GUEST_LOGIN_CLOSE_MESSAGE_TYPE,
      hostOrigin: document.location.origin
    },
    hostOrigin
  );
};

/** Asks the parent project page to open its guest-login modal (widget iframe). */
export const postGuestLoginOpenRequest = (): void => {
  if (typeof window === "undefined" || window.self === window.top) {
    return;
  }

  window.parent.postMessage(
    {
      type: EMBED_GUEST_LOGIN_OPEN_MESSAGE_TYPE,
      hostOrigin: document.location.origin
    },
    window.location.origin
  );
};
